export default "__VITE_ASSET__CtvU9PuW__"